import React from 'react';
import PropTypes from 'prop-types';
import { trackElement, trackEvent } from '@nexus/fff-analytics';

import Timeline from '../Timeline';
import CollapsiblePanel from '../CollapsiblePanel';
import './SeasonalTimeline.css';
import { handleTrackAndRedirect } from '../../utils/track';

const SeasonalTimeline = ({
  isExpired, isNotSubscribed, data: { timelineSteps, accountPlan }, screenMode,
}) => {
  const handleReactivateOnClick = () => {
    trackElement({ elementName: 'Reactivate' }).then(() => {
      window.location.href = `${process.env.REACT_APP_SITE_URL}/reactivate-my-membership`;
    });
  };

  return (
    <section className="seasonal-timeline">
      <div className="seasonal-timeline__container">
        <CollapsiblePanel title="SEASONAL TIMELINE" screenMode={screenMode}>
          <>
            <div className="seasonal-timeline__timeline__buttons">
              <div className="seasonal-timeline__timeline">
                <Timeline nodeBoxes={timelineSteps} />
              </div>
              <div className="seasonal-timeline__buttons">
                {isNotSubscribed && <a className="fff-btn-primary" href="/activate-membership">ACTIVATE MEMBERSHIP</a>}
                {/* eslint-disable no-nested-ternary */}
                {isExpired && !isNotSubscribed
                  ? (
                    <button
                      type="button"
                      className="fff-btn-primary"
                      onClick={handleReactivateOnClick}
                    >
                      REACTIVATE
                    </button>
                  )
                  : (accountPlan === 'ANNUAL' && !isNotSubscribed ? (
                    <button
                      type="button"
                      className="fff-btn-primary"
                      onClick={() => handleTrackAndRedirect(() => trackEvent({ ctaName: 'SEND A FREE BOX' }),
                        `${process.env.REACT_APP_SITE_URL}/invite-friends`)}
                    >
                      SEND A FREE BOX
                    </button>
                  ) : (!isNotSubscribed && (
                  <button
                    type="button"
                    className="fff-btn-primary"
                    onClick={() => handleTrackAndRedirect(() => trackEvent({ ctaName: 'UPGRADE TO ANNUAL' }),
                      `${process.env.REACT_APP_SITE_URL}/upgrade-confirmation`)}
                  >
                    UPGRADE TO ANNUAL
                  </button>
                  )))}
                <button
                  type="button"
                  className="fff-btn-primary-black-outline"
                  onClick={() => handleTrackAndRedirect(() => trackElement({ elementName: 'ADD TO CALENDAR' }),
                    'https://support.fabfitfun.com/hc/en-us/articles/360052444092/')}
                  rel="noreferrer"
                >
                  ADD TO CALENDAR
                </button>
              </div>
            </div>
            <div className="divider" />
          </>
        </CollapsiblePanel>
      </div>
    </section>
  );
};

SeasonalTimeline.defaultProps = {
  data: {},
  screenMode: 'mobile',
  isExpired: false,
  isNotSubscribed: false,
};

SeasonalTimeline.propTypes = {
  screenMode: PropTypes.string,
  data: PropTypes.shape({
    accountPlan: PropTypes.string,
    currentTimelineSteps: PropTypes.arrayOf(PropTypes.string),
    timelineSteps: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      message: PropTypes.string,
      order: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      date: PropTypes.string,
      group: PropTypes.string,
    })),
  }),
  isExpired: PropTypes.bool,
  isNotSubscribed: PropTypes.bool,
};

export default SeasonalTimeline;
